
import Swiper from 'swiper';
import SwiperCore, { Navigation, Autoplay, EffectFade, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Autoplay, EffectFade, Pagination]);
window.Swiper = Swiper;

import GLightbox from 'glightbox';
const lightbox = GLightbox({
    selector: '[data-lightbox]',
});

import cookieConsent from './cookieConsent';

import Alpine from 'alpinejs';
Alpine.start();

document.addEventListener(
    'DOMContentLoaded',
    document.body.classList.remove('preload')
);
